module.exports = __webpack_public_path__ + "media/images/icon_level_silver-06c990e34b4e4a2770462f9126ade2df.png";